import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = [
    "dropdownContainer",
    "icon",
    "button",
    "content"
  ]

  toggle(e) {
    if (e) {
      e.preventDefault()
    }

    this.dropdownContainerTarget.dataset.expanded =
      this.dropdownContainerTarget.dataset.expanded === "true" ? "false" : "true"

    this.contentTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-180")
  }

  hide(event) {
    const buttonClicked = this.buttonTarget.contains(event.target)
    const expanded = this.dropdownContainerTarget.dataset.expanded === "true"

    if (expanded && !buttonClicked) {
      this.toggle()
    }
  }
}
